import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  width: 700px;
  height: 46px;
  left: 0px;
  top: 409px;
`;

export const ObjectiveText = styled.img`
  position: absolute;
  width: 624px;
  height: 36px;
  left: 41px;
  top: 367px;
`;
export const ImagesBarHeader = styled.img`
  position: absolute;
  width: 700px;
  height: 47px;
  left: 0px;
  top: 0px;
`;

export const BlackBar = styled.img`
  position: absolute;
  width: 320px;
  height: 30px;
  left: 31px;
  top: 7px;

  transform: matrix(1, 0, 0, -1, 0, 0);
`;

export const Hpxp = styled.img`
  position: absolute;
  width: 140.74px;
  height: 23px;
  left: 47px;
  top: 12px;
`;

export const TextSkills = styled.text`
  position: absolute;
  width: 60px;
  height: 10px;
  left: 378px;
  top: 18px;

  font-family: 'Press Start 2P';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  /* identical to box height */

  text-transform: uppercase;
`;
